import axios from "axios";
import { BASE_URL } from "./apiConfig";
import { getStoreId, getToken } from "./helper";

export const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

API.interceptors.request.use(
  (config) => {
    const storeId = getStoreId();
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    } else {
      config.headers["Authorization"] = null;
    }
    if (storeId) {
      config.headers["store-id"] = storeId;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const statusCode = error.response.status;
    if (statusCode === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/authentication/login";
    } else if (statusCode === 404) {
      const isStoreAdmin = window.location.pathname.includes("store-admin");
      window.location.href = isStoreAdmin ? "/store-admin/404" : "/404";
    } else if (statusCode === 503) {
      const isStoreAdmin = window.location.pathname.includes("store-admin");
      window.location.href = isStoreAdmin ? "/store-admin/503" : "/503";
    }
    return Promise.reject(error);
  }
);
